<div class="sidebar-right-content">
  @if (!session) {
    <h3 class="title">{{ 'passwordReset.title' | translate }}</h3>
    <dx-form
      *appReloadOnLangChange
      (onEditorEnterKey)="requestSession($event)"
    >
      <dxi-item
        dataField="email"
        [editorOptions]="editorOptions"
      >
        <dxo-label text="{{ 'labels.email' | translate }}"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="{{ 'error.input_required' | translate }}"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="email"
          message="{{ 'error.email_format' | translate }}"
        ></dxi-validation-rule>
      </dxi-item>
    </dx-form>
    <app-button
      class="dx-auto-width"
      [type]="'default'"
      [stylingMode]="'contained'"
      (buttonClick)="requestSession()"
      [label]="'passwordReset.request' | translate"
    >
    </app-button>
  } @else {
    <h3 class="title">{{ 'passwordReset.title' | translate }}</h3>
    <dx-form *appReloadOnLangChange (onEditorEnterKey)="finalizeSession($event)">
      <dxi-item dataField="newPassword" [editorOptions]="passwordEditorOptions">
        <dxo-label text="{{ 'labels.password' | translate }}"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="{{ 'error.input_required' }}"
        ></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        dataField="newPasswordConfirm"
        editorType="dxTextBox"
        [editorOptions]="passwordEditorOptions"
      >
        <dxo-label text="{{ 'labels.passwordRepeat' | translate }}"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="{{ 'error.input_required' }}"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="compare"
          [comparisonTarget]="passwordComparison"
          message="{{ 'error.password_missmatch' | translate }}"
        ></dxi-validation-rule>
      </dxi-item>
    </dx-form>
    <app-button
      [type]="'default'"
      [stylingMode]="'contained'"
      [label]="'passwordReset.finalize' | translate"
      class="dx-auto-width"
      (buttonClick)="finalizeSession()"
    >
    </app-button>
  }
</div>
